import React, { useState } from 'react';

const TermsPage: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="website-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <a href="/" className="logo-link">
              <img src="/assets/LogoBrown.png" alt="SobCof Logo" className="logo-img" />
            </a>
          </div>
          <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <a href="/" className="nav-link">Ana Sayfa</a>
            <a href="/#features" className="nav-link">Özellikler</a>
            <a href="/#how-it-works" className="nav-link">Nasıl Çalışır</a>
            <a href="/#download" className="nav-link">İndir</a>
            <a href="/contact" className="nav-link">İletişim</a>
            <a href="/cafe-partnership" className="nav-link">Kafe Partnerliği</a>
          </div>
          <div className="nav-toggle" onClick={toggleMobileMenu}>
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </div>
        </div>
      </nav>

      {/* Legal Content */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-header">
            <h1>Kullanım Koşulları</h1>
          </div>

          <div className="legal-body">
            <div className="section">
              <h2>1. Genel Hükümler</h2>
              <p>
                Bu Kullanım Koşulları ("Koşullar"), SobCof mobil uygulaması ve web sitesi 
                ("Hizmet") kullanımını düzenler. Hizmeti kullanarak bu koşulları kabul etmiş sayılırsınız.
              </p>
              <p>
                SobCof, kahve severlerin gerçek kafe ortamlarında tanışmasını sağlayan 
                sosyal eşleşme platformudur.
              </p>
            </div>

            <div className="section">
              <h2>2. Uygunluk ve Hesap Oluşturma</h2>
              <h3>2.1 Yaş Sınırı</h3>
              <ul>
                <li>Hizmetimizi kullanmak için en az 18 yaşında olmalısınız</li>
                <li>18 yaş altındaki kullanıcıların hesapları derhal kapatılır</li>
              </ul>

              <h3>2.2 Hesap Gereksinimleri</h3>
              <ul>
                <li>Gerçek ve doğru bilgiler sağlamalısınız</li>
                <li>Sadece bir hesap oluşturabilirsiniz</li>
                <li>Hesap bilgilerinizi güvenli tutmakla yükümlüsünüz</li>
                <li>Hesabınızı başkalarıyla paylaşamazsınız</li>
              </ul>

              <h3>2.3 Kimlik Doğrulama</h3>
              <p>
                Güvenlik amacıyla telefon numarası doğrulaması gereklidir. 
                Premium hesaplar için ek doğrulama talep edilebilir.
              </p>
            </div>

            <div className="section">
              <h2>3. Hizmet Kullanımı</h2>
              <h3>3.1 İzin Verilen Kullanım</h3>
              <ul>
                <li>Gerçek kişiler olarak tanışma ve sosyalleşme</li>
                <li>Kahve kültürü ve ilgi alanları paylaşımı</li>
                <li>Saygılı ve olumlu iletişim</li>
              </ul>

              <h3>3.2 Yasak Faaliyetler</h3>
              <ul>
                <li>Sahte profil oluşturma veya kimlik sahtekarlığı</li>
                <li>Taciz, tehdit veya uygunsuz davranış</li>
                <li>Ticari amaçlı kullanım (izinsiz reklam/satış)</li>
                <li>Spam mesaj gönderme</li>
                <li>Diğer kullanıcıların kişisel bilgilerini toplama</li>
                <li>Yetişkin içerik veya müstehcen materyal paylaşımı</li>
                <li>Nefret söylemi veya ayrımcılık</li>
                <li>Uygulamayı tersine mühendislik ile inceleme</li>
              </ul>
            </div>

            <div className="section">
              <h2>4. İçerik ve Davranış Kuralları</h2>
              <h3>4.1 Profil İçeriği</h3>
              <ul>
                <li>Fotoğraflar sizin olmalı ve gerçek olmalıdır</li>
                <li>Uygunsuz, şiddet içeren veya yanıltıcı içerik yasaktır</li>
                <li>Telif hakkı korumalı içerik paylaşılamaz</li>
              </ul>

              <h3>4.2 Mesajlaşma Kuralları</h3>
              <ul>
                <li>Saygılı ve nezaketli iletişim kurun</li>
                <li>Kişisel bilgilerinizi (adres, telefon) paylaşırken dikkatli olun</li>
                <li>Finansal taleplerde bulunmayın</li>
                <li>Diğer platformlara yönlendirme yapılmamalıdır</li>
              </ul>
            </div>

            <div className="section">
              <h2>5. Premium Üyelik</h2>
              <h3>5.1 Premium Özellikler</h3>
              <ul>
                <li>Sınırsız beğeni hakkı</li>
                <li>Sizi beğenenleri görme</li>
                <li>Gelişmiş filtreler</li>
                <li>Geri alma özelliği</li>
                <li>Genişletilmiş mesafe ayarları</li>
                <li>Gizli mod</li>
              </ul>

              <h3>5.2 Ödeme ve İptal</h3>
              <ul>
                <li>Premium üyelik aylık veya yıllık olarak faturalandırılır</li>
                <li>Otomatik yenileme varsayılan olarak açıktır</li>
                <li>İptal işlemi hesap ayarlarından yapılabilir</li>
                <li>İptal sonrası mevcut dönem sonuna kadar hizmet devam eder</li>
              </ul>
            </div>

            <div className="section">
              <h2>6. Gizlilik ve Veri Koruma</h2>
              <p>
                Kişisel verilerinizin işlenmesi <a href="/privacy">Gizlilik Politikamız</a> 
                kapsamında düzenlenir. Hizmeti kullanarak veri işleme uygulamalarımızı 
                kabul etmiş olursunuz.
              </p>
            </div>

            <div className="section">
              <h2>7. Fikri Mülkiyet</h2>
              <p>
                SobCof uygulaması, logosu, tasarımı ve içeriği SobCof Teknoloji A.Ş.'nin 
                fikri mülkiyetidir. İzinsiz kullanım, kopyalama veya dağıtım yasaktır.
              </p>
            </div>

            <div className="section">
              <h2>8. Hesap Askıya Alma ve Sonlandırma</h2>
              <h3>8.1 Askıya Alma Nedenleri</h3>
              <ul>
                <li>Kullanım koşullarının ihlali</li>
                <li>Diğer kullanıcılardan şikayetler</li>
                <li>Şüpheli veya zararlı aktivite</li>
                <li>Sahte profil tespiti</li>
              </ul>

              <h3>8.2 Hesap Silme</h3>
              <p>
                Hesabınızı istediğiniz zaman silebilirsiniz. Silinen hesaplar 30 gün 
                boyunca kurtarılabilir, sonrasında kalıcı olarak silinir.
              </p>
            </div>

            <div className="section">
              <h2>9. Sorumluluk Sınırlaması</h2>
              <p>
                SobCof, kullanıcılar arasındaki etkileşimlerden sorumlu değildir. 
                Gerçek hayatta tanışma kararı tamamen kullanıcıların sorumluluğundadır. 
                Güvenliğiniz için:
              </p>
              <ul>
                <li>İlk buluşmaları kalabalık yerlerde yapın</li>
                <li>Kişisel bilgilerinizi koruyun</li>
                <li>Şüpheli davranışları bildirin</li>
                <li>Güvenlik kurallarımızı takip edin</li>
              </ul>
            </div>

            <div className="section">
              <h2>10. Değişiklikler</h2>
              <p>
                Bu koşulları zaman zaman güncelleyebiliriz. Önemli değişiklikler 
                durumunda size bildirimde bulunacağız. Güncellenmiş koşullar, 
                yayınlandığı tarihten itibaren geçerli olacaktır.
              </p>
            </div>

            <div className="section">
              <h2>11. İletişim</h2>
              <p>
                Kullanım koşulları hakkında sorularınız için bizimle iletişime geçebilirsiniz:
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <a href="/" className="logo-link">
                  <img src="/assets/LogoWhite.png" alt="SobCof Logo" />
                </a>
              </div>
              <p className="footer-description">
                Kahve severler için sosyal keşif platformu. En iyi kafeleri keşfet, yeni insanlarla tanış.
              </p>
              <div className="social-links">
                <a href="https://instagram.com/sobcof" title="Instagram" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                <a href="https://tiktok.com/@sobcof" title="TikTok" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                <a href="https://twitter.com/sobcof" title="Twitter" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                <a href="https://youtube.com/@sobcof" title="YouTube" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
              </div>
            </div>

            <div className="footer-section">
              <h4>Ürün</h4>
              <ul>
                <li><a href="/#features">Özellikler</a></li>
                <li><a href="/#premium">Premium</a></li>
                <li><a href="/#download">İndir</a></li>
                <li><a href="/#security">Güvenlik</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Destek</h4>
              <ul>
                <li><a href="/help">Yardım Merkezi</a></li>
                <li><a href="/contact">İletişim</a></li>
                <li><a href="/feedback">Geri Bildirim</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Yasal</h4>
              <ul>
                <li><a href="/privacy">Gizlilik Politikası</a></li>
                <li><a href="/terms">Kullanım Koşulları</a></li>
                <li><a href="/cookies">Çerez Politikası</a></li>
                <li><a href="/gdpr">KVKK</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026 SobCof. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
